import { createAsyncThunk } from "@reduxjs/toolkit";
import apiRequest from "../../../services/api";

// get program assignment

export const fetchProgramAssignment = createAsyncThunk(
  "programs/fetch_program_assignment",
  async (body) => {
    let query = {
      page: body.page ? body.page : 1,
      page_size: body.page_size ? body.page_size : 10,
    };
    if (body.search) {
      query.search = body.search;
    }
    if (body.status) {
      query.status = body.status === "All" ? "" : body.status;
    }
    if (body.programName) {
      query.program__title = body.programName;
    }
    if (body.program) {
      query.program = body.program;
    }
    // organization, clinic, role, user_type
    if (body.organization) {
      query.organization = body.organization;
    }
    if (body.clinic) {
      query.clinic = body.clinic;
    }
    if (body.role) {
      query.role = body.role;
    }
    if (body.userType) {
      query.user_type = body.userType;
    }
    if (body.orderBy) {
      query.ordering = body.orderBy;
    }
    if (body.group) {
      query.group = body.group;
    }
    if (body.user) {
      query.user_email = body.user;
    }
    const programAssignment = await apiRequest.get(`v2/programs/assignments/`, {
      headers: { organization: body.userOrganization.org_id },
      params: query,
    });
    return programAssignment.data;
  }
);

// create program assignment

export const createProgramAssignment = createAsyncThunk(
  "programs/create_program_assignment",
  async (body) => {
    const createProgramAssignment = await apiRequest.post(
      `v2/programs/${body.programID}/assignments/`,
      body.data,
      {
        headers: { organization: body.userOrganization.org_id },
      }
    );
    return createProgramAssignment.data;
  }
);

// edit program assignment

export const editProgramAssignment = createAsyncThunk(
  "programs/edit_program_assignment",
  async (body) => {
    try {
      const editProgramAssignment = await apiRequest.put(
        `v2/programs/assignment/${body.assignmentId}/`,
        body.data,
        {
          headers: { organization: body.userOrganization.org_id },
        }
      );
      return editProgramAssignment.data;
    } catch (error) {
      return error?.response?.data
        ? {
            status: "error",
            data: Object.values(error?.response?.data).flat(1),
          }
        : { status: "error", data: ["Something went wrong!"] };
    }
  }
);

// program assignment detail

export const fetchProgramAssignmentDetail = createAsyncThunk(
  "programs/fetch_program_assignment_detail",
  async (body) => {
    const programAssignmentDetail = await apiRequest.get(
      `v2/programs/assignment/${body.id}/`,
      {
        headers: { organization: body.userOrganization.org_id },
      }
    );
    return programAssignmentDetail.data;
  }
);

export const deleteProgramAssignment = createAsyncThunk(
  "programs/delete_program_assignment",
  async (body) => {
    const deleteProgramAssignment = await apiRequest.delete(
      `v2/programs/assignment/${body.id}/`,
      {
        headers: { organization: body.userOrganization.org_id },
      }
    );
    return deleteProgramAssignment.data;
  }
);
